import { IMAGE_BASE_URL } from "constants/configConstants";

export const MAP_TYPES = {
  ROAD_VIEW: "ROAD_VIEW",
  STREET_VIEW: "STREET_VIEW",
};

export const LIMIT_NEARBY_LOCATION = 4;
export const nearbyLocationFilterOptions = [
  {
    value: "universities",
    name: "Universities",
    icon: "icon-graduation-cap-square",
    marker_icon: { url: `${IMAGE_BASE_URL}shop-marker.svg`, scaledSize: { width: 30, height: 30 } },
    skip: true,
  },
  {
    value: "store",
    name: "Supermarkets",
    filter: { radius: 16000, type: ["store"] },
    icon: "icon-cart-shopping-squar",
    marker_icon: { url: `${IMAGE_BASE_URL}shop-marker.svg`, scaledSize: { width: 30, height: 30 } },
  },
  {
    value: "restaurant",
    name: "Cafes",
    filter: { radius: 16000, type: ["restaurant"] },
    icon: "icon-pot-food-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}restaurant-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "subway_station",
    name: "Metro",
    filter: { radius: 16000, type: ["subway_station"] },
    icon: "icon-commute-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}Metro-Marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "bus_station",
    name: "Bus Stops",
    filter: { radius: 16000, type: ["bus_station"] },
    icon: "icon-bus-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}commute-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
  {
    value: "airport",
    name: "Airports",
    filter: { radius: 16000, type: ["airport"] },
    icon: "icon-plane-departure-square",
    marker_icon: {
      url: `${IMAGE_BASE_URL}departure-marker.svg`,
      scaledSize: { width: 30, height: 30 },
    },
  },
];

export default nearbyLocationFilterOptions;
